<div *transloco="let t;" fxLayout="row" fxLayoutGap="5px">
  <div class="icon-button" fxLayoutAlign="center center" (click)="openInfoDialog()">
    <mat-icon>info</mat-icon>
  </div>
  <div>
    {{ t('reset_after_free_parking') }}
    {{ reset_text }}
  </div>
</div>
